import script from "./utility-switching-agent-nav-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./utility-switching-agent-nav-menu.vue?vue&type=script&setup=true&lang=ts"

import "./utility-switching-agent-nav-menu.vue?vue&type=style&index=0&id=66e8b0ec&lang=scss"

const __exports__ = script;

export default __exports__